/* eslint-disable no-nested-ternary */
import { Backdrop, Grid, LinearProgress } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';
import {
  getContractTypes,
  getJobs,
  getStudentAffiliate,
  postContractFiles,
  sendContractFromSchool,
} from '@webapps/business';
import {
  Button,
  FormikAutocompletePx,
  FormikDatePicker,
  FormikTextField,
  TextField,
  useLocalStorage,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import CitySearchDropdown from 'components/CitySearchDropdown';
import Information from 'components/Icons/Information';
import { RYTHME_SCOLAIRE } from 'config/constants';
import { format } from 'date-fns';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import * as yup from 'yup';

const contractSchema = yup.object().shape({
  schoolSystem: yup.string(),
  startDate: yup.string().required('Requis'),
  endDate: yup.string().required('Requis'),
  direction: yup.string().required('Requis'),
  city: yup.string().required('Requis'),
  schoolAffiliate: yup.string(),
  businessAffiliate: yup.string(),
  externalOrganization: yup.object().shape({
    name: yup.string().when('direction', {
      is: 'in-out',
      then: yup.string().required('Requis'),
    }),
    phone: yup.string().when('direction', {
      is: 'in-out',
      then: yup.string().required('Requis'),
    }),
    // .matches(
    //   /^(\+33)[0-9]{9,10}$/,
    //   "Le numéro de téléphone n'est pas valide (+33XXX...)"
    // ),
    // phone: yup.string().required('Requis'),
    email: yup
      .string()
      .email('E-mail invalide')
      .when('direction', {
        is: 'in-out',
        then: yup.string().required('Requis'),
      }),
    activityLabel: yup.string().when('direction', {
      is: 'in-out',
      then: yup.string().required('Requis'),
    }),
    contractType: yup.string().when('direction', {
      is: 'in-out',
      then: yup.string().required('Requis'),
    }),
  }),
});

const Contract = ({ close, refetch, refetchInfoContract, selectedStudent }) => {
  const {
    classes,
    css,
    theme: { spacing },
  } = useStyles(styles);

  const { addToast } = useToast();
  const [file, setFile] = useState();
  const [progress, setProgress] = useState(20);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [keywordRequest, setKeywordRequest, removeKeywordRequest] =
    useLocalStorage('jobsKeyword');

  const { data: { data: infoBusiness = [] } = {} } = useQuery(
    getStudentAffiliate,
    {
      key: ['infoStudentBusinessAffiliate', selectedStudent?.student?.id],
      variables: {
        id: selectedStudent?.student?.id,
        type: 'business',
        status: 'enclosed',
      },
    }
  );

  const { data: { content: jobs = [] } = {} } = useQuery(getJobs, {
    key: ['jobs', keywordRequest],
    variables: { keyword: keywordRequest || '' },
  });

  const { data: contractTypes = [] } = useQuery(getContractTypes, {
    key: 'contractTypes',
  });

  const {
    data: dataContract,
    error: errorCreateContract,
    isLoading: isLoadingCreateContract,
    isSuccess: isSuccessCreateContract,
    mutateAsync: mutateSendContract,
  } = useMutation(sendContractFromSchool);

  const {
    error: errorLoadingFile,
    isLoading: isLoadingFile,
    isSuccess: isSuccessLoadingFile,
    mutateAsync: mutateFiles,
  } = useMutation(postContractFiles);
  const formik = useFormik({
    initialValues: {
      schoolSystem: '',
      endDate: '',
      startDate: '',
      city: '',
      direction:
        selectedStudent?.student?.classroom && selectedStudent?.student?.team
          ? 'in-in'
          : selectedStudent?.student?.classroom &&
            !selectedStudent?.student?.team
            ? 'in-out'
            : 'out-out',
      schoolAffiliate: selectedStudent?.id || '',
      businessAffiliate: infoBusiness[0]?.id || '',
      externalOrganization: {
        name: '',
        phone: '',
        email: '',
        activityLabel: '',
        contractType: '',
      },
    },
    validationSchema: contractSchema,
    enableReinitialize: true,
    onSubmit: async ({ endDate, startDate, ...values }) => {
      await mutateSendContract({
        data: {
          endDate: format(new Date(endDate), "yyyy-MM-dd'T'HH:mm:ss"),
          startDate: format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ss"),
          attachment: file,
          ...values,
        },
      });
    },
  });

  const handleAddFiles = (fileimp) => {
    setFile(fileimp);
  };

  useEffect(async () => {
    if (errorCreateContract) {
      addToast({
        status: 'error',
        message: 'Erreur lors de la création du contrat.',
      });
    }
    if (isSuccessCreateContract) {
      setProgress(100);
      addToast({
        status: 'success',
        message: 'Le contrat a bien été transmis',
      });
      refetch();
      refetchInfoContract();
      close();
      // await mutateFiles({
      //   data: {
      //     file,
      //   },
      //   id: dataContract?.data?.id,
      // });
    }
  }, [errorCreateContract, isSuccessCreateContract]);

  useEffect(async () => {
    if (errorLoadingFile) {
      addToast({
        status: 'error',
        message: 'Problème pour charger le fichier',
      });
    }
    if (isSuccessLoadingFile) {
      setProgress(100);
      addToast({
        status: 'success',
        message: 'Le contrat a bien été transmis',
      });
      refetch();
      refetchInfoContract();
      close();
    }
  }, [errorLoadingFile, isSuccessLoadingFile]);

  const [errorPhone, setErrorPhone] = useState(false);

  const [phoneClasses, setPhoneClasses] = useState('phoneInput');
  const phoneClassesRef = React.useRef();
  phoneClassesRef.current = phoneClasses;

  const handleChangePhone = (phoneInfo) => {

    if (phoneInfo) {
      if (isValidPhoneNumber(phoneInfo)) {
        formik.setFieldValue('externalOrganization.phone', phoneInfo);
        setErrorPhone(false);
        setPhoneClasses('phoneInput');
      } else {
        setErrorPhone(true);
        setPhoneClasses('phoneInputError');
      }
    }
  };

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column'
      })}
    >
      <Backdrop
        className={css({
          position: 'absolute',
          zIndex: 10000,
          color: '#fff',
        })}
        open={isLoadingCreateContract || isLoadingFile}
      >
        <div
          className={css({
            width: 300,
            background: 'white',
            padding: spacing(1),
            borderRadius: 5,
            display: 'flex',
            alignItems: 'center',
            color: 'blue',
          })}
        >
          <LinearProgress
            className={css({
              height: 10,
              borderRadius: 3,
              flex: 1,
              marginRight: spacing(1),
            })}
            value={progress}
            variant="determinate"
          />
          {progress}%
        </div>
      </Backdrop>
      <Grid container xs={12}>
        {!selectedStudent?.student?.team && (
          <div className={css({ marginTop: spacing(0), color: '#152652', marginBottom: '12px', display: 'flex', flexDirection: 'row' })}>
            <div>
              <Information className={css({ color: '#0060F9', height: 20, width: 20, marginRight: 10 })} />
            </div>
            <div>
              L’étudiant n’a pas
              encore trouvé une entreprise sur Linkpick. Voulez vous continuer
              cette action ?
            </div>
          </div>
        )}
        <Grid
          className={css({
            display: 'flex',
            alignItems: 'center',
            marginTop: spacing(3.5),
          })}
          item
          xs={12}
        >
          <DescriptionIcon color="primary" />
          <div
            className={css({
              marginLeft: spacing(1),
              color: '#152652',
            })}
          >
            Importez le document (PDF uniquement)
          </div>
        </Grid>
        <Grid
          className={css({
            display: 'flex',
            marginTop: spacing(2.5),
            flexDirection: 'column',
          })}
          item
          xs={12}
        >
          <div
            className={css({
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            })}
          >
            <div>{file ? file.name : 'Aucun document'}</div>
            <Button
              component="label"
              disableElevation
              size="small"
              variant="contained"
              style={{ color: '#152652' }}
            >
              Importer
              <input
                accept="application/pdf"
                hidden
                inputProps={{
                  accept: 'application/pdf',
                }}
                onChange={(event) => {
                  handleAddFiles(event.target.files[0]);
                }}
                type="file"
              />
            </Button>
          </div>
        </Grid>
        <Grid className={css({ marginTop: spacing(2.5) })} container>
          <Grid item xs={12}>
            <TextField
              disabled
              fullWidth
              label="Nom et prénom de l'apprenant"
              value={`${selectedStudent?.student?.firstname} ${selectedStudent?.student?.lastname}`}
              borderRadius={6}
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(2.5) })} container>
          <Grid item xs={12}>
            <CitySearchDropdown formik={formik} name='city' />
          </Grid>
        </Grid>
        {selectedStudent?.student?.team ? (
          <>
            <Grid className={css({ marginTop: spacing(2.5) })} container>
              <Grid item xs={12}>
                <TextField
                  disabled
                  fullWidth
                  label="Entreprise"
                  value={selectedStudent?.student?.team?.business?.name}
                  borderRadius={6}
                />
              </Grid>
            </Grid>
            <Grid className={css({ marginTop: spacing(2.5) })} container>
              <Grid item xs={12}>
                {infoBusiness[0]?.contractType?.label && (
                  <TextField
                    disabled
                    fullWidth
                    label="Type de contrat"
                    value={infoBusiness[0]?.contractType?.label}
                    borderRadius={6}
                  />
                )}
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            <Grid className={css({ marginTop: spacing(2.5) })} container>
              <Grid item xs={12}>
                <FormikTextField
                  formik={formik}
                  fullWidth
                  label="Nom de l'entreprise"
                  name="externalOrganization.name"
                  borderRadius={6}
                />
              </Grid>
            </Grid>
            <Grid className={css({ marginTop: spacing(2.5) })} container>
              <Grid item xs={12}>
                <FormikTextField
                  formik={formik}
                  fullWidth
                  label="E-mail de l'entreprise"
                  name="externalOrganization.email"
                  borderRadius={6}
                />
              </Grid>
            </Grid>
            <Grid className={css({ marginTop: spacing(2.5) })} container>
              <Grid className={classes.phoneInputContainer} item xs={12}>
                <PhoneInput
                  className={[classes[phoneClassesRef.current]]}

                  countryCallingCodeEditable={false}
                  defaultCountry="FR"
                  international
                  limitMaxLength
                  name="phone"
                  onChange={(phone) => {
                    handleChangePhone(phone);
                  }}
                  placeholder={<FormattedMessage id="createUserForm.phone" />}
                  value={formik.values.phone}
                />
              </Grid>
              <div className={classes.phoneError}>
                <div />
                <div>
                  {errorPhone && (
                    <div className={css({ color: 'red' })}>
                      Le numéro n'est pas correct
                    </div>
                  )}
                </div>
              </div>
            </Grid>
            <Grid className={css({ marginTop: spacing(2.5) })} container>
              <Grid item xs={12}>
                <FormikAutocompletePx
                  defaultValue=""
                  formik={formik}
                  fullWidth
                  getOptionLabel={(option) => option.label || ''}
                  getOptionSelected={(option, value) =>
                    value.ogr === option.ogr
                  }
                  label="Indiquer l'intitulé du poste"
                  name="externalOrganization.activityLabel"
                  onInputChange={(event, value) => {
                    setKeywordRequest(value);
                  }}
                  options={jobs}
                  pathValue="ogr"
                  value={
                    jobs.find(
                      ({ ogr }) =>
                        ogr === formik.values.externalOrganization.activityLabel
                    ) || null
                  }
                  borderRadius={6}
                />
              </Grid>
            </Grid>
            <Grid className={css({ marginTop: spacing(2.5) })} container>
              <Grid item xs={12}>
                <FormikAutocompletePx
                  defaultValue=""
                  formik={formik}
                  fullWidth
                  getOptionLabel={(option) => option.label || ''}
                  getOptionSelected={(option, value) => value.id === option.id}
                  label="Type de contrat"
                  name="externalOrganization.contractType"
                  options={contractTypes}
                  pathValue="id"
                  borderRadius={6}
                  value={
                    contractTypes.find(
                      ({ id }) =>
                        id === formik.values.externalOrganization.contractType
                    ) || null
                  }
                />
              </Grid>
            </Grid>
          </>
        )}
        <Grid
          className={css({
            marginTop: spacing(2.5),
            display:
              formik?.values?.externalOrganization?.contractType ===
                '4028818a7eb67dc0017eb68138a60005' ||
                infoBusiness[0]?.contractType?.id ===
                '4028818a7eb67dc0017eb68138a60005'
                ? 'none'
                : 'unset',
          })}
          container
        >
          <Grid item xs={12}>
            <FormikAutocompletePx
              defaultValue=""
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              getOptionSelected={(option, value) =>
                value.value === option.value
              }
              label="Rythme scolaire"
              name="schoolSystem"
              options={RYTHME_SCOLAIRE}
              pathValue="value"
              value={
                RYTHME_SCOLAIRE.find(
                  ({ value }) => value === formik.values.schoolSystem
                ) || null
              }
              borderRadius={6}
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(2.5) })} container>
          <Grid item xs={12}>
            <FormikDatePicker
              formik={formik}
              fullWidth
              variant='outlined'
              label="Date de début de contrat"
              name="startDate"
              borderRadius={6}
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(2.5) })} container>
          <Grid item xs={12}>
            <FormikDatePicker
              formik={formik}
              fullWidth
              variant='outlined'
              label="Debut de fin de contrat"
              minDate={formik.values.startDate}
              name="endDate"
              borderRadius={6}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(2),
          })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            disabled={isLoadingCreateContract || !file}
            fullWidth
            onClick={formik.handleSubmit}
            type="submit"
            variant="contained"
          >
            Envoyer
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

const styles = ({ spacing }) => ({
  phoneInputContainer: {
    height: '40px',
  },
  phoneInput: {
    height: '100%',
    '& > *': {
      backgroundColor: '#F3F7FF',
      border: '1px solid #C0D9FF',
      borderRadius: 5,
      // transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
      // outline: '2px solid red',
      padding: spacing(0, 2),
      height: '100%',
      color: '#152652',
      '&:focus': {
        color: '#152652',
        outline: '1px solid #C0D9FF',
        borderColor: '#C0D9FF',
      },
    },
  },
  phoneInputError: {
    height: '100%',
    '& > *': {
      backgroundColor: '#F3F7FF',
      border: '1px solid #F50057',
      borderRadius: 5,
      padding: spacing(0, 2),
      height: 'calc(100% - 2px)',
      color: '#737373',
      // '&:hover': {
      //   border: '1px solid black',
      // },
      '&:focus': {
        border: '1px solid #F50057',
        color: '#737373',
        outline: 'none',
      },
    },
  },
  phoneError: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
});

Contract.propTypes = {
  selectedStudent: PropTypes.string,
  refetch: PropTypes.func,
  close: PropTypes.func,
  refetchInfoContract: PropTypes.func,
};

export default Contract;